import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidatorUtils {
  static valueMatchWithAutoCompleteField(options: Array<any>): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const ctrlValue = control.value;
      if (options && ctrlValue && typeof ctrlValue === 'string') { // if select an option from the list, then no validation
        const currentValue = options?.filter(
          (item) => item.label === ctrlValue
        );
        if (currentValue.length) {
          return null;
        } else {
          return { ValueNotMatch: true };
        }
      } else {
        return null;
      }
    };
  }
}
